import {clearAll, domainMonitorSelectedIdsSelector} from 'features/domain/model/domainMonitorSlice';
import {useMonitorSelection, IUseMonitorSelection} from 'entities/monitor';

export const useDomainMonitorSelection = (): IUseMonitorSelection =>
    useMonitorSelection(domainMonitorSelectedIdsSelector, clearAll);

export default useDomainMonitorSelection;
